import type { UserAPI } from '@sydle/ui-api';
import { getAPI } from '@sydle/ui-api';
import { createSiteAPI } from '../api/site-api';
import languages from './languages';

export default async (): Promise<void> => {
  const languagePath = window.location.pathname.split('/')[1];
  const language = languages.regularLanguages.find((lang) => lang.link.includes(languagePath));
  const hreflang = language?.hreflang || 'en';

  getAPI<UserAPI>('userAPI')?.setCurrentLanguage(hreflang);

  createSiteAPI();
};
